import { useTheme, useMediaQuery } from '@material-ui/core';

export const useIsDesktop = (): boolean => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return isDesktop;
};
